export default __webpack_public_path__ + "static/media/Animations_Bar15.e21d1aee.svg";